import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendLoadOptionsTable extends Layout {
    buttonAddSendLoadOption: Button;
    sourceMCControl: DataSource;
    sourceMcSendLoadOptions: DataSource;
    tableSendLoadOptions: Table;
}
